<template>
  <div>
    <div class="head" style="height: 140px">
      <div class="w1200">
        <div class="logo fl" :style="'background-image:url(' + configure.logo1 + ')'">
          <router-link to="/"></router-link>
        </div>
        <el-input placeholder="请输入搜索资源名称" v-model="name" class="fl">
          <el-select slot="prepend" v-model="categoryId" placeholder="资源类型" style="width: 110px;text-align: center;">
            <el-option label="全部" value=""> </el-option>
            <el-option v-for="item in categoryData" :key="item.id" :label="item.typeName" :value="item.id">
            </el-option>
          </el-select>
          <i slot="suffix" @click="search" style="color: #0096ff; cursor: pointer" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="text" class="fl" @click="$router.push({ name: 'my' })" style="margin-right: 15px"><i class="iconfont icontouxiang"></i>我的资源</el-button>
        <el-button type="text" class="fl" @click="$router.push({ name: 'resourceUpload' })"><i class="iconfont iconshangchuan-01"></i>上传资源</el-button>
        <el-button type="text" class="fl countBtn" v-if="auditRole" @click="$router.push({ name: 'audit' })"><i class="el-icon-tickets"></i> <span
                class="count">{{count}}</span>
          待审批
        </el-button>
      </div>
      <div class="nav">
        <div class="w1200">
          <ul>
            <li style="width: 240px; flex-shrink: 0">
              <el-popover placement="bottom" width="200" trigger="hover">
                <el-tabs v-model="activeName" class="popoverSection">
                  <el-tab-pane :label="section.label" v-for="(section, i) in sectionData" :key="'section' + i" :name="section.id">
                    <ul>
                      <li v-for="(subject, j) in section.children" :key="'subject_' + i + '_' + j" @click="goResource(section, subject)">
                        <span>{{ subject.label }}</span>
                      </li>
                    </ul>
                  </el-tab-pane>
                </el-tabs>
                <!-- <el-button slot="reference"
                  > <i class="el-icon-arrow-down"></i
                ></el-button> -->
                <span slot="reference">{{ breadcrumb[1] }} <i class="el-icon-arrow-down"></i></span>
              </el-popover>
            </li>
            <li :class="$route.path.split('/')[1] == 'index' ? 'on' : ''">
              <router-link to="/">首页</router-link>
            </li>
            <li :class="$route.path.split('/')[1] == 'resource' ? 'on' : ''">
              <router-link to="/resource">资源中心</router-link>
            </li>
            <!-- <li><router-link to="">题库组卷</router-link></li> -->
            <li :class="$route.path.split('/')[1] == 'special' ? 'on' : ''">
              <router-link to="/special">专题资源</router-link>
            </li>
            <li :class="$route.path.split('/')[1] == 'classroom' ? 'on' : ''">
              <router-link to="/classroom">三师课堂</router-link>
            </li>
            <li :class="$route.path.split('/')[1] == 'statistics' ? 'on' : ''">
              <router-link to="/statistics">统计中心</router-link>
            </li>
            <li>
              <a :href="configure.helpUrl" target="_blank">帮助中心</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main" style="position: relative">
      <router-view :sectionData="sectionData" :activeName="activeName" :breadcrumb="breadcrumb" :breadcrumbData="breadcrumbData" :init1="init1"
                   :searchName="name" :searchTypeId="categoryId" @replace="analysisUrl" ref="ref"></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import role from "../mixins/role";
export default {
  inject: ["reload"],
  data() {
    return {
      name: "",
      categoryId: "",
      categoryData: [],
      breadcrumb: [],
      breadcrumbData: {
        section: "",
      },
      activeName: "",
      sectionData: [],
      init1: 0,
      uploadUrl: "",
      count: "",
    };
  },
  mixins: [role],
  methods: {
    getCount() {
      this.$ajax
        .post("/server/third/resource/approval/count/toAudit")
        .then((res) => {
          if (this.auditRole == 1) {
            this.count = res.countResource + res.countThird;
          } else if (this.auditRole == 2) {
            this.count = res.countResource;
          } else if (this.auditRole == 3) {
            this.count = res.countThird;
          } else {
            this.count = 0;
          }
        });
    },
    search() {
      if (this.$route.path == "/resource") {
        // this.analysisUrl();
        this.$refs.ref.search1();
      } else {
        this.$router.push({
          name: "resource",
          params: { resourceName: this.name, resourceTypeId: this.categoryId },
        });
      }
    },
    init() {
      this.getData();
      this.getCount();
      this.analysisUrl();
      this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    },
    toParameter(section, subject) {},
    getData() {
      this.$ajax
        .post("/server/resource/type/getResourceTypeList")
        .then((res) => {
          this.categoryData = res;
        });
    },
    goResource(i, j, k) {
      window.sessionStorage.setItem(
        "currentDirectory",
        JSON.stringify({
          sectionId: i.id,
          sectionName: i.label,
          subjectId: j.id,
          subjectName: j.label,
          versionId: k === undefined ? "" : k.id,
          gradeId: "",
          volumeId: "",
          relationDataId: "",
          chapterId: "",
        })
      );
      let b = ["资源平台", i.label + j.label];
      if (k != undefined) {
        b.push(k.label);
      }
      window.sessionStorage.setItem("breadcrumb", JSON.stringify(b));
      // if (this.$route.path == "/resource") {
      this.analysisUrl();
      // } else {
      // this.$router.push({ name: "resource" });
      // this.$router.go(0)
      // }
    },
    analysisUrl() {
      this.sectionData = JSON.parse(
        window.sessionStorage.getItem("sectionData")
      );
      this.breadcrumbData = JSON.parse(
        window.sessionStorage.getItem("currentDirectory")
      );
      this.activeName = this.breadcrumbData.sectionId;
      this.breadcrumb = JSON.parse(window.sessionStorage.getItem("breadcrumb"));
      this.init1++;
    },
  },
  computed: {
    ...mapState(["userModule"]),
    ...mapState(["configure"]),
    auditRole() {
      // let role = ["Admin", "AreaManager", "Auditor", "ThirdResourceManager"]; //超管\区管\资源中心审核员\三师资源审核员
      let roleCode = this.userModule.roles.map((item) => item.roleCode);
      //0没有权限，1超管、区管、资源&&三师审核员，2资源中心审核员，3三师资源审核员
      if (
        roleCode.includes("Admin") ||
        roleCode.includes("AreaManager") ||
        (roleCode.includes("Auditor") &&
          roleCode.includes("ThirdResourceManager"))
      ) {
        return 1;
      } else if (roleCode.includes("Auditor")) {
        return 2;
      } else if (roleCode.includes("ThirdResourceManager")) {
        return 3;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.countBtn {
  position: relative;
}
.count {
  position: absolute;
  /* top: 10px;
  right: -30px; */
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px !important;
  line-height: 18px !important;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  transform: translateY(-50%) translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/page/indexResources.vue